import React, { useState } from "react"
import toast from "react-hot-toast"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { Col, Row } from "reactstrap"
import { useFormik } from "formik"
import { DragDropContext, Droppable } from "react-beautiful-dnd"

import {
   CreateTrailerWarranty,
   DeleteTrailerWarranty,
   GetTrailerWarrantyListing,
   UpdateTrailerWarranty,
   UpdateTrailerWarrantyListingSequence,
   GetWarrantyListing,
} from "../../../api/api.service"
import { AutoComplete } from "../../../components/AutoComplete"
import { Button } from "../../../components/Button"
import { DataTable } from "../../../components/DataTable"
import { SearchBox } from "../../../components/SearchBox"
import ActiveInactiveSwitch from "../CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import DeleteModal from "../CommonUI/Modal/DeleteModal"
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest"
import { ConfiguratorPackagesStatus } from "../../../constants"
import { convertToSelectOptions } from "../../../utils/commonUtils"

import eyeIcon from "../../../assets/images/icons/eye-icon.svg"
import DeleteIcon from "assets/images/icons/finance-vendor-mang-del-icon.svg"
import editIcon from "../../../assets/images/icons/edit-icon.svg"

import {
   FIELDS_NAME,
   initialValues,
   validationSchema,
   TOGGLE_STATUS,
} from "./FormConfig"
import ManageWarranties from "./ManageWarranties"
import WarrantyDetails from "./WarrantyDetails"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import useAsyncSelect from "hooks/useAsyncSelect"
import ManageImportGlobalWarrantyModal from "./ManageImportGlobalWarrantyModal"
import TruncatedTextWithTooltip from "components/CustomTooltip/CustomTooltip"

const COLUMNS = {
   WARRANTY_NAME: "Warranty Name",
   WARRANTY_YEAR: "Year",
   WARRANTY_PRICE: "Price",
   STATUS: "Status",
   ACTIONS: "Actions",
   DEFAULT: "Default",
   POPULAR_WARRANTY: "Popular Warranty",
}
const DATA_KEY = "data"
const TOTAL_KEY = "total"

const handleUpdateExecution = async (id, data) => {
   let res = await UpdateTrailerWarranty(id, data)
   toast.success("Warranty has been updated successfully !")
}
const Warranty = ({}) => {
   const { trailerId } = useParams()
   const [statusFilters, setStatusFilters] = useState(null)
   const [selection, setSelection] = useState({})
   const [isLoading, setIsLoading] = useState(false)
   const [selectedWarranty, setSelectedWarranty] = useState(null)
   const [openSelectWarrantiesModal, setOpenSelectWarrantiesModal] =
      useState(false)
   const [selectedWarranties, setSelectedWarranties] = useState([])
   const [eventsType, setEventsType] = useState({
      isManage: null,
      isViewDetails: null,
      isDelete: null,
   })

   const {
      data,
      isFetching,
      page,
      searchText,
      pageSize,
      total,
      handleSearchChange,
      request,
      handlePageClick,
      onChangePageSize,
      setTableDataChangeLoading,
      tableDataChangeLoading,
      setData,
   } = useLocalPaginatedRequest({
      requestFn: GetTrailerWarrantyListing,
      params: {
         trailerId: trailerId,
         limit: -1,
         direction: "ASC",
         column: "sequenceNo",
         ...(statusFilters?.value && { status: statusFilters?.value }),
      },
      deps: [statusFilters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   const {
      setSelectedOption: setSelectedWarrantyOption,
      selectEntity: warrantiesOptions,
      setSelectEntity: setWarrantiesOptions,
      handleSearchOnOptions: handleSearchWarranty,
      selectedOption: selectedWarrantyOption,
      handleSelectAOption: handleSelectAWarrantyOption,
   } = useAsyncSelect({
      apiFunc: GetWarrantyListing,
      labelKey: "name",
      valueKey: "id",
      restrictExecutionOnRender: false,
      params: {
         limit: -1,
      },
      modifyLabel: true,
      handleLabelModification: options => {
         return options.map(item => {
            const { description, ...rest } = item
            return {
               ...rest,
               label: item.name || "",
            }
         })
      },
      onOptionSelect: option => {
         setSelectedWarranty(option)
      },
   })

   const formik = useFormik({
      enableReinitialze: true,
      initialValues: {
         ...initialValues,
      },
      validationSchema: validationSchema,
      onSubmit: values => {
         handleSubmit(values)
      },
   })

   const handleInitManage = obj => {
      setEventsType(prev => ({ ...prev, isManage: true }))
      setSelection(obj)
   }

   const handleInitViewDetails = obj => {
      setEventsType(prev => ({
         ...prev,
         isViewDetails: true,
      }))

      setSelection(obj)
   }

   const handleSelectStatusOption = option => {
      setStatusFilters(option)
   }

   const handleStatusChange = async (currStatus, id) => {
      let status =
         currStatus === ConfiguratorPackagesStatus.Active
            ? ConfiguratorPackagesStatus.Inactive
            : ConfiguratorPackagesStatus.Active
      let dataClone = [...data]
      dataClone.map(el => {
         if (el?.id == id) el.status = status
      })
      setData(dataClone)
      let payload = {
         status: status,
      }
      try {
         setTableDataChangeLoading(true)
         let res = await UpdateTrailerWarranty(id, payload)
         toast.success("Warranty status has been updated !")
      } catch (err) {
         let dataClone = [...data]
         dataClone.map(el => {
            if (el?.id == id) el.status = currStatus
         })
         setData(dataClone)
      } finally {
         setTableDataChangeLoading(false)
      }
   }

   const handleInitDelete = obj => {
      setSelection(obj)
      setEventsType(prev => ({
         ...prev,
         isDelete: true,
      }))
   }

   const handleSubmit = values => {
      let bodyData = {
         configuratorTrailerId: Number(trailerId),
         name: values[FIELDS_NAME.NAME],
         price: Number(values[FIELDS_NAME.PRICE]),
         year: Number(values[FIELDS_NAME.YEAR]),
         status: values[FIELDS_NAME.STATUS],
         description: values[FIELDS_NAME.DESCRIPTION],
         isDefault: values[FIELDS_NAME.DEFAULT],
         isPopular: values[FIELDS_NAME.IS_POPULAR],
      }

      if (selection?.id) {
         handleUpdate(bodyData)
      } else {
         handleAdd(bodyData)
      }
   }

   const handleUpdate = async data => {
      const payload = {
         ...data,
      }

      try {
         setIsLoading(true)
         await handleUpdateExecution(selection?.id, payload)
         handleModalClose()
         request()
      } finally {
         setIsLoading(false)
      }
   }
   const handleAdd = async data => {
      try {
         setIsLoading(true)
         let res = await CreateTrailerWarranty(data)
         toast.success("Warranty has been added successfully !")
         request()
         handleModalClose()
      } catch (error) {
      } finally {
         setIsLoading(false)
      }
   }

   const handleDragEnd = async result => {
      try {
         if (!result.destination) return

         const items = Array.from(data)
         const [reorderedItem] = items.splice(result.source.index, 1)
         items.splice(result.destination.index, 0, reorderedItem)
         setData(items)

         let payload = {
            trailerId: Number(trailerId),
            sequenceItems: items.map((trailerObj, ind) => ({
               id: Number(trailerObj.id),
               sequenceNo: ind,
            })),
         }

         await UpdateTrailerWarrantyListingSequence(payload)
         toast.success("Sequence updated successfully!")
      } catch (err) {
         toast.error("Failed to update sequence")
      }
   }

   const handleModalClose = () => {
      setSelection({})
      setEventsType(prev => ({
         ...prev,
         isManage: false,
      }))
      formik.resetForm()
   }

   return (
      <>
         <div className="mb-3 trailer-container">
            <div className="d-flex align-items-center justify-content-end admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
               <Button
                  className={`header-button headerButtonResponsive global-selection-button`}
                  title="Select Warranties"
                  onClick={() => setOpenSelectWarrantiesModal(true)}
               />

               <Button
                  className={`header-button headerButtonResponsive global-selection-button`}
                  title="Add Warranty"
                  onClick={() => handleInitManage({})}
               />
            </div>
         </div>

         <div className="mb-3">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness ">
               <div className="status-search-con wh-im-dpgi-status  me-2 ">
                  <AutoComplete
                     value={statusFilters}
                     isClearable
                     onChange={val => handleSelectStatusOption(val)}
                     isSearchable={false}
                     placeholder="Select status"
                     customStyles={autoCompleteStyles.STYLE_SIX}
                     classNamePrefix="status-header-search-admin"
                     options={convertToSelectOptions(
                        ConfiguratorPackagesStatus
                     )}
                  />
               </div>
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="vendor-table-search-icon"
                     conClass="vendor-table-search-inner-class"
                     searchText={searchText}
                     onChange={handleSearchChange}
                  />
               </div>
            </div>
         </div>

         <Row>
            <Col md={12}>
               <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="droppable">
                     {provided => (
                        <div
                           {...provided.droppableProps}
                           ref={provided.innerRef}
                        >
                           <DataTable
                              isDraggable={true}
                              droppablePlaceholder={provided.placeholder}
                              data={data}
                              tableClasses="package-table"
                              loading={isFetching}
                              config={[
                                 {
                                    title: COLUMNS.WARRANTY_NAME,
                                    className: "",
                                    render: data => (
                                       <TruncatedTextWithTooltip
                                          text={data.name}
                                       />
                                    ),
                                 },

                                 {
                                    title: COLUMNS.WARRANTY_PRICE,
                                    className: "",
                                    render: data =>
                                       data?.price
                                          ? `$${Number(data?.price).toFixed(2)}`
                                          : "$0.00",
                                 },

                                 {
                                    title: COLUMNS.WARRANTY_YEAR,
                                    className: "",
                                    render: data => data.year || "-",
                                 },

                                 {
                                    title: COLUMNS.STATUS,
                                    className: "",
                                    render: data => (
                                       <ActiveInactiveSwitch
                                          isDisable={tableDataChangeLoading}
                                          id={data.id}
                                          name={`${data.id}`}
                                          onChange={e =>
                                             handleStatusChange(
                                                data?.status,
                                                data?.id
                                             )
                                          }
                                          isChecked={
                                             data?.status ==
                                             ConfiguratorPackagesStatus.Active
                                          }
                                       />
                                    ),
                                 },
                                 {
                                    title: COLUMNS.POPULAR_WARRANTY,
                                    className: "",
                                    render: data =>
                                       data?.isPopular
                                          ? TOGGLE_STATUS.Yes
                                          : TOGGLE_STATUS.No,
                                 },

                                 {
                                    title: COLUMNS.DEFAULT,
                                    className: "",
                                    render: data =>
                                       data?.isDefault
                                          ? TOGGLE_STATUS.Yes
                                          : TOGGLE_STATUS.No,
                                 },

                                 {
                                    title: COLUMNS.ACTIONS,

                                    render: data => (
                                       <div className="d-flex gap-2 pointer">
                                          <img
                                             src={eyeIcon}
                                             onClick={() =>
                                                handleInitViewDetails(data)
                                             }
                                          />

                                          <img
                                             src={editIcon}
                                             onClick={() =>
                                                handleInitManage(data)
                                             }
                                          />

                                          <img
                                             src={DeleteIcon}
                                             onClick={() =>
                                                handleInitDelete(data)
                                             }
                                          />
                                       </div>
                                    ),
                                 },
                              ]}
                           />
                        </div>
                     )}
                  </Droppable>
               </DragDropContext>
            </Col>
         </Row>

         {eventsType.isViewDetails && (
            <WarrantyDetails
               isOpen={eventsType.isViewDetails}
               id={selection?.id}
               onToggleModal={() => {
                  setSelection({})
                  formik.resetForm()
                  setEventsType(prev => ({
                     ...prev,
                     isViewDetails: false,
                  }))
               }}
               formik={formik}
               isLoading={isLoading}
            />
         )}
         {eventsType.isDelete && (
            <DeleteModal
               isOpen={eventsType.isDelete}
               toggleFunction={() => {
                  formik.resetForm()
                  setEventsType(prev => ({ ...prev, isDelete: false }))
               }}
               id={selection?.id}
               apiFunction={DeleteTrailerWarranty}
               title={"Warranty"}
               requestFunction={() => {
                  setSelection(null)
                  request()
               }}
            />
         )}

         {eventsType.isManage && (
            <ManageWarranties
               isLoading={isLoading}
               isOpen={eventsType.isManage}
               isDetailView={false}
               id={selection?.id}
               onToggleModal={() => {
                  setSelection({})
                  setEventsType(prev => ({
                     ...prev,
                     isManage: false,
                  }))
               }}
               formik={formik}
            />
         )}

         <ManageImportGlobalWarrantyModal
            isOpen={openSelectWarrantiesModal}
            onToggleModal={() => {
               setOpenSelectWarrantiesModal(false)
               setSelectedWarranties([])
            }}
            warrantiesOptions={warrantiesOptions}
            setWarrantiesOptions={setWarrantiesOptions}
            handleSearchWarranty={handleSearchWarranty}
            selectedWarranties={selectedWarranties}
            setSelectedWarranties={setSelectedWarranties}
            trailerId={trailerId}
            onSuccess={request}
            existingTrailerWarranties={data || []}
         />
      </>
   )
}

export default Warranty
